import { useDispatch, useSelector } from 'react-redux';
import { EditableQuestion } from '../../../../../types';
import { selectEditedQuestionId } from '../../../../../../../redux/questionnaire/selectors';
import { setEditedQuestionId } from '../../../../../../../redux/questionnaire/actions';

export const useEditing = (question: EditableQuestion) => {
  const dispatch = useDispatch();
  const editedQuestionId = useSelector(selectEditedQuestionId);

  const startEditing = () => {
    dispatch(setEditedQuestionId(question._id));
  };

  const cancelEditing = () => {
    dispatch(setEditedQuestionId(null));
  };

  return {
    isEditing: editedQuestionId === question._id,
    startEditing,
    cancelEditing
  };
};
